
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 13">
  <path
    d="M5.5 0.673828C3.98122 0.673828 2.75 1.87267 2.75 3.35151C2.75 4.83036 3.98122 6.0292 5.5 6.0292C7.01878 6.0292 8.25 4.83036 8.25 3.35151C8.25 1.87267 7.01878 0.673828 5.5 0.673828ZM5.5 1.7449C6.41127 1.7449 7.14999 2.46421 7.14999 3.35151C7.14999 4.23882 6.41127 4.95812 5.5 4.95812C4.58873 4.95812 3.85001 4.23882 3.85001 3.35151C3.85001 2.46421 4.58873 1.7449 5.5 1.7449ZM11 11.9201C11 8.96242 8.53756 6.56474 5.5 6.56474C2.46244 6.56474 0 8.96242 0 11.9201C0 12.2159 0.246243 12.4556 0.55 12.4556C0.853757 12.4556 1.1 12.2159 1.1 11.9201C1.1 9.55396 3.06995 7.63581 5.5 7.63581C7.93005 7.63581 9.9 9.55396 9.9 11.9201C9.9 12.2159 10.1462 12.4556 10.45 12.4556C10.7538 12.4556 11 12.2159 11 11.9201Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'User',
    }) as DefineComponent
    </script>
    